const APPS_MIXPANEL_PREFIX = 'Apps Page';

const trackMixpanel = (eventName, params) => {
    try {
        if (typeof window !== 'undefined' && window.mixpanel?.track) {
            window.mixpanel.track(eventName, params);
        }
    } catch (error) {
        // Analytics must never block Apps configuration flows.
        console.error(error);
    }
};

export const trackAppsEvent = (eventSuffix, params) => {
    trackMixpanel(`${APPS_MIXPANEL_PREFIX}: ${eventSuffix}`, params);
};

export const trackAppsRefresh = () => {
    trackMixpanel(`${APPS_MIXPANEL_PREFIX} Refresh apps`);
};

export const trackSessionDedupWindowSave = params => {
    trackMixpanel('Save Time Between Sessions', params);
};
